import { UploadFile } from '@mui/icons-material'
import { FormControl, Typography, FormHelperText } from '@mui/material'
import { useCallback, CSSProperties, useEffect, useState } from 'react'
import { useDropzone } from 'react-dropzone'
import { UseControllerProps, useController } from 'react-hook-form'

interface Props extends UseControllerProps { }

export default function AppDropzone(props: Props) {
    const { fieldState, field } = useController({ ...props, defaultValue: null });

    const dzStyles: CSSProperties = {
        display: 'flex',
        border: 'dashed 3px #eee',
        borderColor: '#eee',
        borderRadius: '5px',
        paddingTop: '30px',
        alignItems: 'center',
        height: 200,
        width: '100%', // Set width to 100% here
    }

    const dzActive = {
        borderColor: '#CD853F'
    }

    const [fontSize, setFontSize] = useState('2rem'); // Default font size

    const updateFontSize = () => {
        if (window.innerWidth <= 600) {
            setFontSize('1rem'); // Adjust font size for smaller screens
        } else {
            setFontSize('2rem'); // Default font size for larger screens
        }
    };

    useEffect(() => {
        updateFontSize(); // Initial font size calculation

        window.addEventListener('resize', updateFontSize); // Listen for window resize events

        return () => {
            window.removeEventListener('resize', updateFontSize); // Clean up event listener
        };
    }, []);

    const onDrop = useCallback((acceptedFiles: any) => {
        acceptedFiles[0] = Object.assign(acceptedFiles[0], { preview: URL.createObjectURL(acceptedFiles[0]) });
        field.onChange(acceptedFiles[0]);
        console.log('File dropped:', acceptedFiles[0]); // Add a logging statement here
    }, [field])

    const { getRootProps, getInputProps, isDragActive } = useDropzone({ onDrop })

    return (
        <div {...getRootProps()} style={{ width: '100%' }}>
            <FormControl style={isDragActive ? { ...dzStyles, ...dzActive } : dzStyles} error={!!fieldState.error} >
                <input {...getInputProps()} />
                <UploadFile sx={{ fontSize: '100px', color: '#CD853F' }} />
                <Typography variant='h4' style={{ fontSize }}>Attach/Drop Image ...</Typography>
                <FormHelperText>{fieldState.error?.message}</FormHelperText>
            </FormControl>
        </div>
    )
}